import Color from 'color'
import React from 'react'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import ColorPalette from './ColorPalette'
import withRedux from './withRedux'

const ColorInput = FormElement(
  ({
    colors,
    onExpandButtonClick,
    name,
    onChange,
    enabled = true,
    size = 1,
    colorLabel,
    withCheckbox,
    alwaysExpanded = false,
    value,
    className,
    disabled = false,
    withPopoverIcon,disableExpandButton
  }: IColorInputProps) => {
    return (
      <React.Fragment>
        <Input
          style={{ display: 'none' }}
          name={name}
          type={'color'}
          size={size}
          onChange={onChange}
          value={value}
          className={className}
          withPopoverIcon={withPopoverIcon}
        />
        <ColorPalette
          disabled={disabled}
          size={size}
          colors={colors}
          value={enabled ? value : '#fff'}
          withCheckbox={withCheckbox}
          onChange={onChange}
          colorLabel={colorLabel}
          enabled={enabled}
          alwaysExpanded={alwaysExpanded}
          className={className}
          onExpandButtonClick={onExpandButtonClick}
          withPopoverIcon={withPopoverIcon}
          disableExpandButton={disableExpandButton}
        />
      </React.Fragment>
    )
  },
)

export default withReduxForm<IColorInputProps>(withRedux(ColorInput))
export { ColorInput }

export interface IColorInputProps extends IFormElementProps {
  value?: string
  colors: Color[]
  withCheckbox?: boolean
  withPopoverIcon?: boolean
  enabled?: boolean
  onExpandButtonClick?: () => void
  colorLabel?: string
  alwaysExpanded?: boolean
  disableExpandButton?: boolean
}
